<div class="mx-5 mb-5" id="myPdf" *ngIf="deliveryRequests">
  <div
    class="mx-5 my-5 print-wrap page{{ j + 1 }}"
    id="page{{ j }}"
    *ngFor="let item of slices; let j = index"
  >
    <div class="row mx-5">
      <div class="col-6 text-left mt-5">
        <img
          class="img-fluid"
          style="width: 60%"
          src="../../../assets/img/modal/intigrow.png"
        />
        <h4>INTIGROW SA</h4>
        <p>24 rue Ibn hazem Andalousie,</p>
        <p>Menzah 6 Ariana</p>
        <p>Tél : 56 83 76 52</p>
        <p>info@intigo.tn</p>
        <p>www.intigo.tn</p>
      </div>
      <div class="col-6 text-center mt-5">
        <h3>{{ deliveryRequests[0].pickUpJob ? "Livraison" : "Pickup" }} :</h3>

        <div class="text-center">
          <h6>Nom du Chauffeur: {{ deliveryRequests[0]?.driver?.name }}</h6>
          <h6>
            Téléphone du Chauffeur: {{ deliveryRequests[0]?.driver?.tel }}
          </h6>
          <h6>Date: {{ today | date: "dd/MM/yyyy hh:mm" }}</h6>
          <h6>Nombre de colis: {{ deliveryRequests.length }}</h6>
          <h6>Montant à collecter: {{ pdfTotal }} DT</h6>

          <div class="col text-center" *ngIf="jobsRequestGroupId">
            <qrcode
              [qrdata]="jobsRequestGroupId"
              [width]="qrwidth"
              [errorCorrectionLevel]="'M'"
            ></qrcode>
          </div>
        </div>
        <br />
      </div>
    </div>
    <div class="row mx-5 pb-5">
      <br />
      <br />
      <br />
      <table class="table table-striped">
        <thead class="items-header-section table-header">
          <tr>
            <th scope="col">Numéro</th>
            <th scope="col">Client</th>
            <th scope="col" *ngIf="jobsType === 'dropOff'">Client final</th>
            <th
              scope="col"
              *ngIf="jobsType === 'dropOff' && config.showFinalClientPhone"
            >
              N. de téléphone de client final
            </th>
            <th scope="col" *ngIf="jobsType === 'pickUp'">
              N. de téléphone de client
            </th>
            <th scope="col" *ngIf="jobsType === 'dropOff'">
              Adresse de client final
            </th>
            <th scope="col" *ngIf="jobsType === 'pickUp'">Adresse de client</th>
            <th scope="col">Prix</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let req of slices[j].requests; let i = index">
            <td scope="row">{{ req?.nid }}</td>
            <td class="ar" *ngIf="jobsType === 'dropOff'">
              {{ req?.business?.nomCommercial }}
            </td>
            <td class="ar" *ngIf="jobsType === 'pickUp'">
              {{ req?.business?.nomCommercial }}
            </td>
            <td *ngIf="jobsType === 'dropOff'">
              {{ req?.deliveredToName }}
            </td>
            <td *ngIf="jobsType === 'pickUp'">{{ req?.business?.tel }}</td>
            <td *ngIf="jobsType === 'dropOff' && config.showFinalClientPhone">
              {{ req?.deliveredToPhone }}
            </td>
            <td class="ar" *ngIf="jobsType === 'pickUp'">
              {{ req?.pickUp?.pickUpAddress }}
            </td>
            <td class="ar" *ngIf="jobsType === 'dropOff'">
              {{ req?.dropOffAddress }}
            </td>
            <td>{{ req?.amount }}DT</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<iframe
  class="d-none"
  frameBorder="0"
  id="sample-pdf"
  style="right: 0; top: 53px; bottom: 0; height: 400px; width: 100%"
></iframe>

<a id="pdf-download-link" title="Download PDF File">Download PDF file</a>
